// these constants is up to you, maybe you won't even use them
export const MODAL_TYPE_CONFIRM = 'MODAL_TYPE_CONFIRM';
export const MODAL_TYPE_CANCEL = 'MODAL_TYPE_CANCEL';



// WEBPACK FOOTER //
// ./src/constants/modalResultTypes.js